import { Controller, useFormContext } from 'react-hook-form';
import { FormControlLabel, FormHelperText, MenuItem, Select } from '@mui/material';
import { useGetOperatingUnitsQuery } from '~/api/v2/hooks';

const OperatingUnitIdSelect = () => {
  const { data: operatingUnitsData, isLoading } = useGetOperatingUnitsQuery({});
  const { control } = useFormContext();

  return (
    <FormControlLabel
      label="OPERATING UNIT ID"
      required
      control={
        <Controller
          name="operating_unit_id"
          control={control}
          render={({ field, fieldState }) => (
            <>
              <FormHelperText error={!!fieldState.error}>{fieldState.error?.message}</FormHelperText>
              <Select {...field} value={field.value ?? ''} disabled={isLoading} error={!!fieldState.error}>
                {operatingUnitsData?.map(({ id, name }) => (
                  <MenuItem key={id} value={id}>
                    {name}
                  </MenuItem>
                ))}
              </Select>
            </>
          )}
        />
      }
    />
  );
};

export default OperatingUnitIdSelect;
